import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import TextSuitIcon from "../../../Custom-imeges/Workflows-Icons/TextSuitIcon";
import { ImageSuiteIcon } from "../../../Custom-imeges/Workflows-Icons/ImageSuiteIcon";
import { useAppSelector } from "../../../store/hooks";
import { WorkflowAppType } from "../../../Helper";
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
// import { suiteAppHelper } from "../WorkflowHelper";

interface WorkflowSelectedSuiteProps {
  handleSelectSuiteApp: (suiteType: number, appData: any[]) => void;
  setSelectedSuiteType: (type: number) => void;
  selectedSuiteType: number;
}
const WorkflowSelectedSuite = ({
  handleSelectSuiteApp,
  setSelectedSuiteType,
  selectedSuiteType,
}: WorkflowSelectedSuiteProps) => {
  const allSuitesApps = useAppSelector((s) => s.workflows.textSuitesApps)
  // const allSuitesApps =  suiteAppHelper;



  const WorkflowApps = [
    {
      appName: "Text",
      appType: 1,
      appIcon: <TextSuitIcon className="custom-icon"  size="40px"/>,
      appData: allSuitesApps,
    },
    {
      appName: "Image",
      appType: 2,
      appIcon: <ImageSuiteIcon className="custom-icon" size="40px" />,
      appData: allSuitesApps,
    },
       {
      appName: "Video",
      appType: 3,
      appIcon:  <VideocamOutlinedIcon
          sx={{fill:"var(--Main_icons_color)",width:"40px",height:"40px"}}
        />,
      appData: allSuitesApps,
    },
  ];
  useEffect(() => {
    if (allSuitesApps?.length > 0) {
      handleSelectSuiteApp(WorkflowApps[0].appType, WorkflowApps[0].appData);
      setSelectedSuiteType(WorkflowAppType.TextSuite);
    }
  }, [allSuitesApps]);
  return (
    <Box className="workflow-apps-container">
      {WorkflowApps.map((app: any, i: number) => (
        <Box
          key={i}
          className={`mt-4 mb-4 continer-suit ${
            selectedSuiteType === app.appType && "selected-suit"
          }`}
          onClick={() => handleSelectSuiteApp(app.appType, app.appData)}
        >
          <Box className="container-suite-icon">{app.appIcon}</Box>
          <Typography className="mt-3 suite-word">{app.appName}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default WorkflowSelectedSuite;
